export type IdName = {
  id: string;
  name: string;
}

export const mapToIdName = ([id, name]: [string, string]): IdName => ({id, name});
